export const carouselContent = [
    {
        title: 'Femme nue couchée aucollier(Marie-Thérèse)',
        description: '',
        hash:'https://gateway.btfs.io/btfs/QmVfqQ5kJc1X1aFKnByWRy5BteKdNwSMh9isXVWZN4fpKN',
        url: require('./images/NFT_1.jpeg').default
    },
    {
        title: 'OCEAN FRONT',
        description: '',
        hash:'https://gateway.btfs.io/btfs/QmSHi4BywAjz3Z2ivxPeLVgMY9d82yQGzMQqvBUfRwB5oB',
        url: require('./images/NFT_2.jpeg').default
    },
    {
        title: 'Three Self-Portraits',
        description: '',
        hash:'https://gateway.btfs.io/btfs/QmTUiKKQxSfc2iK9imtw3evELwkAaiRdKzsRqPKvFFrCZs',
        url: require('./images/NFT_3.jpeg').default
    },
    {
        title: 'Computer Society Cover',
        description: '',
        hash:'https://gateway.btfs.io/btfs/QmRr6cE2wirZ5vGeF9YhFH5egb52HcP3mKnoGTUif8bT5h',
        url: require('./images/NFT_4.png').default
    },
    {
        title: 'EVERYDAYS THE FIRST 5000 DAYS',
        description: '',
        hash:'https://gateway.btfs.io/btfs/QmNqEAnvTf6j8vt1tuc2XMkf7qLZED14w7vVRpvFM3Ad51',
        url: require('./images/NFT_5.png').default
    },
    {
        title: 'Morons',
        description: '',
        hash:'https://gateway.btfs.io/btfs/QmZXNhaLkoH98T5raNUcgfxF7vm58iNNCKaMaaWq8qi7NF',
        url: require('./images/NFT_6.png').default
    },
    {
        title: 'PARLAMENTO DE MONOS',
        description: '',
        hash:'https://gateway.btfs.io/btfs/Qmc7ad5inkPtLZsB6XDU94KroGGnTpjiyBe4D191ADzSJE',
        url: require('./images/NFT_7.png').default
    },
    {
        title: 'Stay Free',
        description: '',
        hash:'https://gateway.btfs.io/btfs/QmYbccLPhsGLitm8fBqrgW4eqPi2Ev5MjgMd4WKS7mbNws',
        url: require('./images/NFT_8.png').default
    }
];